import type { FC } from "react";
import { twMerge } from "tailwind-merge";

interface SmallTabsProps {
  tabs: string[];
  selectedTabIndex: number;
  onSelectTabIndex: (newTabIndex: number) => void;
}

export const SmallTabs: FC<SmallTabsProps> = ({
  tabs,
  selectedTabIndex,
  onSelectTabIndex,
}) => {
  return (
    <nav
      aria-label="Tabs"
      className="isolate inline-flex divide-x divide-gray-200 rounded-lg whitespace-nowrap shadow-sm"
    >
      {tabs.map((tab, tabIdx) => {
        return (
          <button
            className={twMerge(
              "group relative min-w-0 cursor-pointer overflow-hidden bg-white px-3 py-2 text-center text-sm font-medium hover:bg-gray-50 focus:z-10",
              selectedTabIndex === tabIdx
                ? "text-foreground"
                : "text-muted-foreground hover:text-gray-700",
              tabIdx === 0 ? "rounded-l-lg" : "",
              tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
            )}
            key={tab}
            onClick={() => {
              onSelectTabIndex(tabIdx);
            }}
            type="button"
          >
            <span>{tab}</span>
            <span
              aria-hidden="true"
              className={twMerge(
                "absolute inset-x-0 bottom-0 h-0.5",
                selectedTabIndex === tabIdx
                  ? "bg-indigo-500"
                  : "bg-transparent",
              )}
            />
          </button>
        );
      })}
    </nav>
  );
};
